import { Chip, Tooltip } from "@mui/material";

interface ShipmentTypeChipProps {
  shipmentType: ShipmentType;
}

function formatShipmentType(shipmentType: ShipmentType): string {
  switch (shipmentType) {
    case "MULTI_SHIPMENT_PROJECT":
      return "Project";
    case "QUOTES_ONLY":
      return "Quotes Only";
    default:
      return shipmentType;
  }
}

function formatShipmentTypeTooltip(shipmentType: ShipmentType): string {
  switch (shipmentType) {
    case "MULTI_SHIPMENT_PROJECT":
      return "Multi-shipment project";
    case "QUOTES_ONLY":
      return "Shipment in quoting phase";
    default:
      return shipmentType;
  }
}

export function ShipmentTypeChip(props: ShipmentTypeChipProps) {
  const { shipmentType } = props;

  // single is the expected default type, so we don't show a chip for it
  if (
    shipmentType === "SINGLE" ||
    shipmentType === "MULTI_SHIPMENT_PROJECT_CHILD"
  ) {
    return null;
  }

  return (
    <Tooltip title={formatShipmentTypeTooltip(shipmentType)}>
      <Chip
        label={formatShipmentType(shipmentType)}
        color="secondary"
        variant="outlined"
        size="small"
      />
    </Tooltip>
  );
}
